import { useState } from "react";
import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

export default function Accordion({
  title,
  subtitle,
  badge,
  defaultOpen = true,
  forceOpen = false,
  children,
}: {
  title: string;
  subtitle?: string;
  badge?: { text: string; filled?: boolean };
  defaultOpen?: boolean;
  forceOpen?: boolean;
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const isExpanded = forceOpen ? true : isOpen;

  return (
    <div className="accordion">
      <button
        className="accordion-header"
        type="button"
        onClick={() => {
          if (forceOpen) return;
          setIsOpen(!isOpen);
        }}
      >
        <div className="accordion-title-block">
          <span className="accordion-title">{title}</span>
          {subtitle && <span className="accordion-subtitle">{subtitle}</span>}
        </div>
        <div className="accordion-meta">
          {badge ? (
            <span className={`section-badge${badge.filled ? " filled" : ""}`}>
              {badge.text}
            </span>
          ) : null}
          <ChevronDown size={16} className={`accordion-chevron${isExpanded ? " open" : ""}`} />
        </div>
      </button>
      {isExpanded && <div className="accordion-content">{children}</div>}
    </div>
  );
}
